import { useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';
import { Tag } from '../../../store/Tags';
import { SrOnlyText, TextSpan } from '../../Atoms/Text';

export interface TagItemProps {
  tag: Tag;
  interactive?: boolean;
  onClick?: (tag: Tag) => void;
  // The caller owns the write, so only it can end the spinner: a row that never refreshes never would.
  updating?: boolean;
}

export const TagItem = ({ tag, interactive, onClick, updating = false }: TagItemProps) => {
  const [isClicked, setIsClicked] = useState(false);

  // A chip that outlives its own write must be clickable again, and must not spin for the next one.
  useEffect(() => {
    if (!updating) setIsClicked(false);
  }, [updating]);
  const DYNAMIC_STYLES = interactive ? 'px-2 max-w-36 justify-center' : 'px-4 max-w-36 justify-between';
  const TAG_STYLES = `flex items-center align-middle rounded-full py-1 text-nowrap h-6 ${DYNAMIC_STYLES}`;

  const handleInteractiveClick = () => {
    if (interactive && onClick) {
      setIsClicked(true);
      onClick(tag);
    }
  };

  return (
    <div
      className={TAG_STYLES}
      style={{ backgroundColor: tag.color }}>
      <TextSpan
        size="xs"
        className={interactive ? 'text-ellipsis overflow-hidden max-w-24' : ''}
        color="white">
        {tag.name}
      </TextSpan>
      {interactive && (
        <button
          className="ml-2 rounded-full hover:text-grey-2"
          onClick={handleInteractiveClick}>
          <SrOnlyText>Remove tag {tag.name}</SrOnlyText>
          <TextSpan
            size="xs"
            color="white"
            className="hover:text-grey-3">
            {isClicked && updating ? (
              <CircularProgress
                size={8}
                color="inherit"
              />
            ) : (
              'X'
            )}
          </TextSpan>
        </button>
      )}
    </div>
  );
};
